/* tslint:disable */
import * as Types from '../../../../../../graphql-api/baskets-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetBasketManagerFiltersQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.BasketManagerFilterQuery>;
}>;


export type GetBasketManagerFiltersQuery = { getBasketManagerFilters?: { brandFilter: Array<{ name: string, value?: string | null, count?: number | null }>, userFilter: Array<{ imageUrl?: string | null, name: string, value?: string | null, count?: number | null }>, statusFilter: Array<{ name: string, value?: string | null, count?: number | null }>, accountFilter: Array<{ name: string, value?: string | null, count?: number | null, externalId?: string | null }>, orderTypeFilter: Array<{ name: string, value?: string | null, count?: number | null }>, assigneeFilter: Array<{ imageUrl?: string | null, name: string, value?: string | null, count?: number | null }> } | null };

export type SimpleFilterFragment = { name: string, value?: string | null, count?: number | null };

export type AccountFiterFragment = { name: string, value?: string | null, count?: number | null, externalId?: string | null };

export const SimpleFilterFragmentDoc = gql`
    fragment simpleFilter on SimpleFilterValue {
  name
  value
  count
}
    `;
export const AccountFiterFragmentDoc = gql`
    fragment accountFiter on AccountFilterValue {
  name
  value
  count
  externalId
}
    `;
export const GetBasketManagerFiltersDocument = gql`
    query GetBasketManagerFilters($query: BasketManagerFilterQuery) {
  getBasketManagerFilters(query: $query) {
    brandFilter {
      ...simpleFilter
    }
    userFilter {
      ...simpleFilter
      imageUrl
    }
    statusFilter {
      ...simpleFilter
    }
    accountFilter {
      ...accountFiter
    }
    orderTypeFilter {
      ...simpleFilter
    }
    assigneeFilter {
      ...simpleFilter
      imageUrl
    }
  }
}
    ${SimpleFilterFragmentDoc}
${AccountFiterFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBasketManagerFiltersGQL extends Apollo.Query<GetBasketManagerFiltersQuery, GetBasketManagerFiltersQueryVariables> {
    document = GetBasketManagerFiltersDocument;
    client = 'baskets';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }